<template>
  <section id="page_not_found">

    <h2>404</h2>
    <h4>That's an error.</h4>

    <p>
      The page you're looking for could not be found.
    </p>
      
  </section>
</template>

<script>
export default {
  name: 'PageNotFound',
  data () {
    return {
      contest_list: contest_list
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/pages/PageNotFound.vue